/* Danish interface text, keyed by the English source exactly as the code
 * passes it to t() / uiText(). One file per area of the app; a key lives in
 * one file only (test/translations.test.ts checks). Wording follows
 * qorpera.com. */
/** Agent and group details, routines, coding sessions. */
export const AGENTS: Record<string, string> = {
	// Agent details (app/views/agent-details.ts, agent-edits.ts)
	"Agent details": "Agentdetaljer",
	Routines: "Rutiner",
	Copied: "Kopieret",
	Edit: "Rediger",
	"Back to agent details": "Tilbage til agentdetaljer",
	"Done: {name} ended this routine": "Færdig: {name} afsluttede rutinen",
	"This routine has ended": "Rutinen er slut",
	"This routine can't be changed from here": "Rutinen kan ikke ændres herfra",
	"Choose a figure and color": "Vælg en figur og farve",
	Reset: "Nulstil",
	"Edit figure": "Rediger figur",
	"An agent needs a name.": "En agent skal have et navn.",
	"An agent needs a title.": "En agent skal have en titel.",
	"An agent needs its responsibilities written down.": "En agent skal have sine ansvarsområder skrevet ned.",
	Saved: "Gemt",
	"Your changes could not be saved.": "Dine ændringer kunne ikke gemmes.",

	// Routines (app/views/agent-routines.ts)
	Finished: "Færdig",
	Cancelled: "Annulleret",
	Sun: "Søn",
	Mon: "Man",
	Tue: "Tir",
	Wed: "Ons",
	Thu: "Tor",
	Fri: "Fre",
	Sat: "Lør",
	"Every 1 day": "Hver dag",
	"Every {count} days": "Hver {count}. dag",
	"Every 1 hour": "Hver time",
	"Every {count} hours": "Hver {count}. time",
	"Every {count} minutes": "Hvert {count}. minut",
	"every day": "hver dag",
	"When {path} or anything under it changes": "Når {path} eller noget i den ændres",
	"When {path} changes": "Når {path} ændres",
	"When a hook receives an event": "Når en hook modtager en hændelse",
	"When a hook receives {types}": "Når en hook modtager {types}",
	"{days} at {time} ({zone})": "{days} kl. {time} ({zone})",
	"Every day at {time}": "Hver dag kl. {time}",
	"Weekdays at {time}": "Hverdage kl. {time}",
	"Weekends at {time}": "Weekender kl. {time}",
	"{days} at {time}": "{days} kl. {time}",
	"Next run": "Næste kørsel",
	"Pause routine": "Sæt rutinen på pause",
	"Resume routine": "Genoptag rutinen",
	"Only owners and admins can pause or resume routines.":
		"Kun ejere og administratorer kan sætte rutiner på pause eller genoptage dem.",
	"Reactivate the agent first": "Genaktivér agenten først",
	"Paused by a member": "Sat på pause af et medlem",
	"Paused by {name}": "Sat på pause af {name}",
	"Paused: it could not start with the access it had": "På pause: den kunne ikke starte med den adgang, den havde",
	"Paused: no model account pays for it": "På pause: ingen modelkonto betaler for den",
	"Paused when its agent was archived": "Sat på pause, da dens agent blev arkiveret",
	"{every} between {start} and {end}, {days} ({zone})": "{every} mellem {start} og {end}, {days} ({zone})",
	"{every} between {start} and {end} ({zone})": "{every} mellem {start} og {end} ({zone})",
	"Routines could not be read. Refresh to try again.": "Rutinerne kunne ikke hentes. Opdater for at prøve igen.",
	"New routine": "Ny rutine",
	"Close routines": "Luk rutiner",
	"next {when}": "næste {when}",
	tomorrow: "i morgen",
	"Paid by you since {date}": "Betalt af dig siden {date}",
	"Paid by the company since {date}": "Betalt af virksomheden siden {date}",
	"Paid by {name} since {date}": "Betalt af {name} siden {date}",
	"Choose a login": "Vælg et login",
	Login: "Login",
	"Use this login": "Brug dette login",
	"Choosing a login lets {name} use it for this routine while you are away. Pause the routine to stop it.":
		"Når du vælger et login, kan {name} bruge det til rutinen, mens du er væk. Sæt rutinen på pause for at stoppe den.",
	"This login can't pay for work while you're away right now. Choose another one.":
		"Dette login kan ikke betale for arbejde, mens du er væk, lige nu. Vælg et andet.",
	"This login has reached its usage limit. Choose another one, or wait until it resets.":
		"Dette login har nået sin forbrugsgrænse. Vælg et andet, eller vent til den nulstilles.",
	"Sign in to this login again in Settings → AI subscriptions, or choose another one.":
		"Log ind på dette login igen under Indstillinger → AI-abonnementer, eller vælg et andet.",
	"Runs wait until this login's usage limit resets.": "Kørslerne venter, til loginnets forbrugsgrænse nulstilles.",
	"Sign in to this login again in Settings → AI subscriptions to let it run.":
		"Log ind på dette login igen under Indstillinger → AI-abonnementer, så rutinen kan køre.",
	"Runs wait until {name} signs in to this login again.":
		"Kørslerne venter, til {name} logger ind på dette login igen.",
	"Runs wait until this login is signed in again.": "Kørslerne venter, til der er logget ind på dette login igen.",
	"The company is stopped, so its routines can't change now.":
		"Virksomheden er stoppet, så dens rutiner kan ikke ændres nu.",
	"You can only choose one of your own logins.": "Du kan kun vælge et af dine egne login.",
	"You can't change who pays for this routine.": "Du kan ikke ændre, hvem der betaler for rutinen.",
	"The login could not be chosen. Try again.": "Login kunne ikke vælges. Prøv igen.",
	Ended: "Afsluttet",
	Done: "Færdig",
	"The agent picks each next run": "Agenten vælger hver næste kørsel",
	"Reading routines…": "Henter rutiner…",
	"{name} has no routines yet.": "{name} har ingen rutiner endnu.",
	"Routines will appear here.": "Rutiner vises her.",
	"Your model accounts could not be read. Try again.": "Dine modelkonti kunne ikke hentes. Prøv igen.",
	"The routine could not be changed. Try again.": "Rutinen kunne ikke ændres. Prøv igen.",
	"The routine could not be changed.": "Rutinen kunne ikke ændres.",
	"Connect a model account in Settings first; a routine runs on the account of the member who last saved it.":
		"Forbind først en modelkonto i Indstillinger; en rutine kører på kontoen hos det medlem, der sidst gemte den.",
	"Routine name": "Rutinens navn",
	"What to do": "Hvad der skal gøres",
	"Interval unit": "Intervallets enhed",
	minutes: "minutter",
	hours: "timer",
	days: "dage",
	Interval: "Interval",
	Days: "Dage",
	Time: "Tidspunkt",
	Reply: "Svar",
	"Model account": "Modelkonto",
	Every: "Hver",
	at: "kl.",
	"Wait until {time} before the first run": "Vent til {time} med den første kørsel",
	"Choose an interval between 5 minutes and 7 days.": "Vælg et interval mellem 5 minutter og 7 dage.",
	"Choose at least one day, a time and a time zone such as Europe/Copenhagen.":
		"Vælg mindst én dag, et tidspunkt og en tidszone som Europe/Copenhagen.",
	"Give the routine a name and say what to do.": "Giv rutinen et navn, og skriv, hvad den skal gøre.",
	"Connect a model account in Settings first.": "Forbind først en modelkonto i Indstillinger.",
	"A ChatGPT plan can't pay for routines that start on a file change or a webhook.":
		"Et ChatGPT-abonnement kan ikke betale for rutiner, der starter på en filændring eller en webhook.",
	"Turn on “Work while you're away” for this ChatGPT plan in Settings first.":
		"Slå først “Arbejd, mens du er væk” til for ChatGPT-abonnementet i Indstillinger.",
	"This routine runs on your own account that works while you're away.":
		"Rutinen kører på din egen konto, der arbejder, mens du er væk.",
	"The routine could not be saved. Your draft is still here.": "Rutinen kunne ikke gemmes. Din kladde er her stadig.",
	"The routine could not be saved.": "Rutinen kunne ikke gemmes.",
	"Nothing changed.": "Intet er ændret.",
	"This routine changed while you were editing it.": "Rutinen blev ændret, mens du redigerede den.",
	"This routine could not be opened.": "Rutinen kunne ikke åbnes.",
	"This routine is no longer available.": "Rutinen findes ikke længere.",
	"What should {name} do?": "Hvad skal {name} gøre?",
	"or every few hours": "eller med jævne mellemrum",
	"or on chosen days": "eller på valgte dage",
	Always: "Altid",
	"When there is news": "Når der er nyt",
	Never: "Aldrig",
	When: "Hvornår",
	"Runs on": "Kører på",
	"Connect a model account in Settings → AI subscriptions first. A routine runs on a member's own account.":
		"Forbind først en modelkonto i Indstillinger → AI-abonnementer. En rutine kører på et medlems egen konto.",

	// Group details (app/views/group-details.ts, group-edits.ts, app/update-group.ts)
	Participants: "Deltagere",
	"Group details": "Gruppedetaljer",
	"Group title": "Gruppens titel",
	"Group subtitle": "Gruppens undertitel",
	"Group description": "Gruppens beskrivelse",
	"Group title cannot be empty.": "Gruppens titel må ikke være tom.",
	"Group description cannot be empty.": "Gruppens beskrivelse må ikke være tom.",
	"Discard changes": "Kassér ændringer",
	"Unavailable agent": "Utilgængelig agent",
	"Unavailable member": "Utilgængeligt medlem",
	"{name} (You)": "{name} (dig)",
	"Participants ({count})": "Deltagere ({count})",
	"Edit participants": "Rediger deltagere",
	"No participants to display.": "Ingen deltagere at vise.",
	"Archived groups cannot be edited.": "Arkiverede grupper kan ikke redigeres.",
	"Only an owner or admin can edit group details.": "Kun en ejer eller administrator kan redigere gruppedetaljer.",
	"Unavailable participant": "Utilgængelig deltager",
	"Unavailable agent — remove to save": "Utilgængelig agent — fjern for at gemme",
	"Choose at least two agents.": "Vælg mindst to agenter.",
	"Save participants": "Gem deltagere",
	"Refreshing group details…": "Opdaterer gruppedetaljer…",
	"Group details are not current yet.": "Gruppedetaljerne er ikke opdaterede endnu.",
	"Group details could not be refreshed.": "Gruppedetaljerne kunne ikke opdateres.",
	"Only an owner or admin can change group chats.": "Kun en ejer eller administrator kan ændre gruppechats.",
	"Wait for this group chat to finish saving.": "Vent, til gruppechatten er gemt.",
	"Choose at least two active agents and current company members, with no duplicate participants.":
		"Vælg mindst to aktive agenter og nuværende medlemmer af virksomheden, uden dobbelte deltagere.",
	"Enter a group name of no more than 256 characters.": "Skriv et gruppenavn på højst 256 tegn.",
	"Enter a group subtitle of no more than 256 characters.": "Skriv en undertitel på højst 256 tegn.",
	"Enter a description for this group chat.": "Skriv en beskrivelse af gruppechatten.",
	"The group chat changes could not be saved.": "Ændringerne i gruppechatten kunne ikke gemmes.",

	// Coding sessions (ui/coding-session.ts, ui/coding-session-thread.ts)
	"Started a coding session in {harness}": "Startede en kodesession i {harness}",
	"{label}. Open the session": "{label}. Åbn sessionen",
	"{count} coding agents": "{count} kodeagenter",
	"{count} need you": "{count} venter på dig",
	"1 needs you": "1 venter på dig",
	"less than a minute": "under et minut",
	"{minutes} min": "{minutes} min",
	"{hours} h {minutes} min": "{hours} t {minutes} min",
	"{hours} h": "{hours} t",
	"{count} file changed": "{count} fil ændret",
	"{count} files changed": "{count} filer ændret",
	"Waiting for a computer": "Venter på en computer",
	"Preparing the workspace": "Gør arbejdsområdet klar",
	"Needs you · your answer is recorded in this thread": "Venter på dig · dit svar gemmes i denne tråd",
	"Needs {name} · paused {duration}": "Venter på {name} · på pause i {duration}",
	"Needs {name} · paused now": "Venter på {name} · på pause nu",
	"Answer sent · waiting for the session": "Svar sendt · venter på sessionen",
	"Waiting for computer hours": "Venter på computertimer",
	"Answer sent · waiting for computer hours": "Svar sendt · venter på computertimer",
	"Opening the pull request": "Åbner pull requesten",
	"Draft PR ready · session kept for follow-ups": "PR-kladde klar · sessionen gemmes til opfølgning",
	"Finished · session kept for follow-ups": "Færdig · sessionen gemmes til opfølgning",
	"Failed · workspace kept": "Mislykkedes · arbejdsområdet er gemt",
	"Cancelled · workspace kept": "Annulleret · arbejdsområdet er gemt",
	"Draft PR ready": "PR-kladde klar",
	"running 1 command": "kører 1 kommando",
	"running {count} commands": "kører {count} kommandoer",
	"standing by": "står klar",
	asleep: "sover",
	"Archived · files kept": "Arkiveret · filerne er gemt",
	Archive: "Arkivér",
	"Stops what it runs and takes it off its machine. Its files are kept, and a new message reopens it.":
		"Stopper det, den kører, og tager den af sin maskine. Filerne gemmes, og en ny besked genåbner den.",
	"Send a message to reopen this session": "Send en besked for at genåbne sessionen",
	"{agent} archived the session": "{agent} arkiverede sessionen",
	"Archived after a long quiet time": "Arkiveret efter lang tids stilhed",
	"You archived the session": "Du arkiverede sessionen",
	"{owner} archived the session": "{owner} arkiverede sessionen",
	Reopened: "Genåbnet",
	"Quiet for a day · asked {agent} whether it can be archived":
		"Stille i en dag · spurgte {agent}, om den kan arkiveres",
	"Quiet for {days} days · asked {agent} whether it can be archived":
		"Stille i {days} dage · spurgte {agent}, om den kan arkiveres",
	"The machine went to sleep": "Maskinen gik i dvale",
	"The machine was replaced with a newer one": "Maskinen blev skiftet ud med en nyere",
	"The session lost its machine": "Sessionen mistede sin maskine",
	"The owner is no longer a member": "Ejeren er ikke længere medlem",
	"{agent} no longer has the repository": "{agent} har ikke længere adgang til repositoriet",
	"Coding is turned off here": "Kodning er slået fra her",
	"The machine stopped": "Maskinen stoppede",
	"The machine restarted": "Maskinen genstartede",
	"The machine got a new disk": "Maskinen fik en ny disk",
	// A coding session's login (20260930551000): why a turn could not run, the move and the offer of other logins.
	"This session's login was removed, so its turn could not run.":
		"Sessionens login blev fjernet, så dens tur kunne ikke køre.",
	"This session's login was turned off by an owner or admin, so its turn could not run.":
		"Sessionens login blev slået fra af en ejer eller administrator, så dens tur kunne ikke køre.",
	"This session's login needs a new sign-in, so its turn could not run.":
		"Sessionens login skal logges ind igen, så dens tur kunne ikke køre.",
	"This session's login no longer allows work while its member is away, so its turn could not run.":
		"Sessionens login tillader ikke længere arbejde, mens medlemmet er væk, så dens tur kunne ikke køre.",
	"This session's login can't pay for work right now, so its turn could not run.":
		"Sessionens login kan ikke betale for arbejde lige nu, så dens tur kunne ikke køre.",
	"Choose another of your logins for it, then send a message to continue.":
		"Vælg et andet af dine logins til den, og send så en besked for at fortsætte.",
	"Only {owner} can choose another login for it.": "Kun {owner} kan vælge et andet login til den.",
	"You moved the session to another login": "Du flyttede sessionen til et andet login",
	"{owner} moved the session to another login": "{owner} flyttede sessionen til et andet login",
	"Allow it to work while you're away again in Settings, AI subscriptions, then choose it here, or choose another of your logins; then send a message to continue.":
		"Tillad det at arbejde, mens du er væk, igen under Indstillinger, AI-abonnementer, og vælg det så her, eller vælg et andet af dine logins; send derefter en besked for at fortsætte.",
	"Continue this session with one of your logins:": "Fortsæt sessionen med et af dine logins:",
	"None of your other logins can pay for this session. Sign in with another one in Settings, AI subscriptions.":
		"Ingen af dine andre logins kan betale for sessionen. Log ind med et andet under Indstillinger, AI-abonnementer.",
	"1 command stopped": "1 kommando stoppet",
	"{count} commands stopped": "{count} kommandoer stoppet",
	"Coding session": "Kodesession",
	"Session transcript": "Sessionens forløb",
	"{count} earlier steps": "{count} tidligere trin",
	"Waiting for a computer to start the session.": "Venter på en computer, der kan starte sessionen.",
	"Nothing reported yet.": "Intet meldt endnu.",
	Step: "Trin",
	"The session has a question.": "Sessionen har et spørgsmål.",
	"You left it to {agent}": "Du overlod det til {agent}",
	"{owner} left it to {agent}": "{owner} overlod det til {agent}",
	"Draft PR #{number} opened": "PR-kladde #{number} åbnet",
	"Draft PR opened": "PR-kladde åbnet",
	"Qorpera lost contact with this session. The workspace is kept; a follow-up starts it again.":
		"Qorpera mistede forbindelsen til sessionen. Arbejdsområdet er gemt; en opfølgning starter den igen.",
	"The company ran out of computer hours. The workspace is kept; a follow-up continues once hours are added.":
		"Virksomheden løb tør for computertimer. Arbejdsområdet er gemt; en opfølgning fortsætter, når der er tilføjet timer.",
	"The session's last turn ended without saving its work or asking a question. The workspace is kept; a follow-up continues it.":
		"Sessionens sidste tur sluttede uden at gemme sit arbejde eller stille et spørgsmål. Arbejdsområdet er gemt; en opfølgning fortsætter den.",
	"The model account paying for this session reached its usage limit. The workspace is kept; a follow-up continues it once the limit resets.":
		"Modelkontoen, der betaler for sessionen, har nået sin forbrugsgrænse. Arbejdsområdet er gemt; en opfølgning fortsætter den, når grænsen er nulstillet.",
	"ChatGPT refused or could not answer the session's request. Check the login that pays for it in Settings → AI subscriptions. The workspace is kept; a follow-up continues it.":
		"ChatGPT afviste eller kunne ikke besvare sessionens forespørgsel. Tjek det login, der betaler for den, under Indstillinger → AI-abonnementer. Arbejdsområdet er gemt; en opfølgning fortsætter den.",
	"The session lost its connection while it was working. The workspace is kept; a follow-up continues it.":
		"Sessionen mistede forbindelsen, mens den arbejdede. Arbejdsområdet er gemt; en opfølgning fortsætter den.",
	"The session could not load the login that pays for it. Check that login in Settings → AI subscriptions. The workspace is kept; a follow-up continues it.":
		"Sessionen kunne ikke hente det login, der betaler for den. Tjek loginnet under Indstillinger → AI-abonnementer. Arbejdsområdet er gemt; en opfølgning fortsætter den.",
	"ChatGPT refused or could not answer the session's request. The member whose login pays for it can check that login in Settings → AI subscriptions. The workspace is kept; a follow-up continues it.":
		"ChatGPT afviste eller kunne ikke besvare sessionens forespørgsel. Det medlem, hvis login betaler for den, kan tjekke loginnet under Indstillinger → AI-abonnementer. Arbejdsområdet er gemt; en opfølgning fortsætter den.",
	"The session could not load the login that pays for it. The member whose login it is can check it in Settings → AI subscriptions. The workspace is kept; a follow-up continues it.":
		"Sessionen kunne ikke hente det login, der betaler for den. Det medlem, der ejer loginnet, kan tjekke det under Indstillinger → AI-abonnementer. Arbejdsområdet er gemt; en opfølgning fortsætter den.",
	"The model account needs to be connected again. The workspace is kept; a follow-up continues it once the account is connected.":
		"Modelkontoen skal forbindes igen. Arbejdsområdet er gemt; en opfølgning fortsætter den, når kontoen er forbundet.",
	"No computer could be started for the session. The workspace is kept; a follow-up tries again.":
		"Der kunne ikke startes en computer til sessionen. Arbejdsområdet er gemt; en opfølgning prøver igen.",
	"One of the session's saves did not finish, and a person must check it first. The workspace is kept; a follow-up continues it after that.":
		"Noget af det, sessionen gemte, blev ikke færdigt, og en person skal tjekke det først. Arbejdsområdet er gemt; en opfølgning fortsætter den derefter.",
	"One of the session's steps got no answer in time. The workspace is kept; a follow-up continues it.":
		"Et af sessionens trin fik ikke svar i tide. Arbejdsområdet er gemt; en opfølgning fortsætter den.",
	"The session took too long and was stopped. The workspace is kept; a follow-up continues it.":
		"Sessionen tog for lang tid og blev stoppet. Arbejdsområdet er gemt; en opfølgning fortsætter den.",
	"Something on Qorpera's side refused one of the session's steps. The workspace is kept; a follow-up continues it.":
		"Noget hos Qorpera afviste et af sessionens trin. Arbejdsområdet er gemt; en opfølgning fortsætter den.",
	"The session was stopped before it finished. The workspace is kept; a follow-up continues it.":
		"Sessionen blev stoppet, før den var færdig. Arbejdsområdet er gemt; en opfølgning fortsætter den.",
	"The session stopped because of an internal error. The workspace is kept; a follow-up continues it.":
		"Sessionen stoppede på grund af en intern fejl. Arbejdsområdet er gemt; en opfølgning fortsætter den.",
	"{count} file": "{count} fil",
	"{count} files": "{count} filer",
	"{count} artifact": "{count} artefakt",
	"{count} artifacts": "{count} artefakter",
	"Draft pull request": "Pull request-kladde",
	"Review changes": "Gennemgå ændringer",
	"Open on GitHub": "Åbn på GitHub",
	"Ask {name} to review": "Bed {name} om at gennemgå",
	"Please review the draft PR #{number} from your coding session {title} and tell me what you think.":
		"Gennemgå PR-kladden #{number} fra din kodesession {title}, og fortæl mig, hvad du synes.",
	"Answer the session": "Besvar sessionen",
	"Follow up on the session": "Følg op på sessionen",
	"Or answer in your own words": "Eller svar med dine egne ord",
	"Follow up on this session": "Følg op på denne session",
	Answer: "Svar",
	"Let {name} decide": "Lad {name} bestemme",
	"Answer {harness}": "Svar {harness}",
	"The session has not started yet": "Sessionen er ikke startet endnu",
	"{harness} is working": "{harness} arbejder",
	"Only {owner} can write to this session. Steer it through {agent}.":
		"Kun {owner} kan skrive til sessionen. Styr den via {agent}.",
	"Back to the conversation": "Tilbage til samtalen",
	"Back to {name}": "Tilbage til {name}",
	"Loading group details": "Henter gruppedetaljer",
};
